import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  scrollEffect();
});


/* ----------------------------------
  　慣性スクロール
---------------------------------- */

const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

/* ----------------------------------
  　お問い合わせ関連
---------------------------------- */
// // //お問い合わせバリデーション
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}


gsap.registerPlugin(ScrollToPlugin);

// お問い合わせスクロール
document.addEventListener('tccf7:scrollTo', e => {
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;

  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: headerHeight
    },
    ease: "power2.inOut"
  });
});


/* ----------------------------------
  スムーススクロール
---------------------------------- */
$(function () {
  function getHeaderHeight(isPageLoad) {
    // ページ読み込み時（#がある場合）とそれ以外でヘッダー高さを変更
    if (isPageLoad) {
      // ページ読み込み時（#がある場合）は、異なる高さを設定
      return window.innerWidth <= 768 ? 70 : 110;  // スマホの場合の高さ調整
    } else {
      // それ以外の場合（クリック時）は通常のヘッダー高さ
      return window.innerWidth <= 768 ? 70 : $('.is_fixed').outerHeight() || 110;
    }
    
  }

  // ページ内リンクをクリックしたとき：アニメーション付き
  $('a[href*="#"]').click(function () {
    if (
      location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
      location.hostname === this.hostname
    ) {
      const hash = this.hash;
      const $target = $(hash);
      if ($target.length) {
        const position = $target.offset().top - getHeaderHeight(false);
        $("html, body").animate({ scrollTop: position }, 600, "swing");
        return false;
      }
    }
  });

  // ページ読み込み時：アニメーションなしで即移動
  if (location.hash) {
    const $target = $(location.hash);
    if ($target.length) {
      const position = $target.offset().top - getHeaderHeight(true);
      $(window).scrollTop(position); // ← アニメーションなしで即スクロール
    }
  }
});


/* ----------------------------------
　humberger menu
---------------------------------- */
window.addEventListener('load', () => {
  let navEle = document.querySelector('.hd_menu-toggle');
  let navWrap = document.querySelector('.hd_nav');

  // メニューボタン（.hd_menu-toggle）をクリックした時の動作
  navEle.addEventListener('click', () => {
    const isOpen = navWrap.classList.contains('is_open');

    navWrap.classList.toggle('is_open', !isOpen);
    navEle.classList.toggle('is_open', !isOpen);
  });
});


/* ----------------------------------
　ヘッダー出現
---------------------------------- */
function toggleHeaderOnScroll() {
  const header = document.querySelector(".header");
  const targets = document.querySelectorAll(".mainimg, .index_mv");
  if (!header || targets.length === 0) return;

  // 複数ある場合 → 一番下までスクロールした位置を基準にする
  let maxBottom = 0;
  targets.forEach(el => {
    const bottom = el.offsetTop + el.offsetHeight;
    if (bottom > maxBottom) maxBottom = bottom;
  });

  if (window.scrollY > maxBottom) {
    header.classList.add("is_fixed");
  } else {
    header.classList.remove("is_fixed");
  }
}

// スクロールイベントを管理する関数
function handleScrollEvent() {
  if (window.innerWidth > 768) {
    // 768pxより大きい時 → スクロールイベントを有効化
    window.addEventListener("scroll", toggleHeaderOnScroll);
    toggleHeaderOnScroll(); // 初期判定も実行
  } else {
    // 768px以下 → スクロールイベントを無効化 & クラス除去
    window.removeEventListener("scroll", toggleHeaderOnScroll);
    const header = document.querySelector(".header");
    if (header) header.classList.remove("is_fixed");
  }
}

// 初回実行
handleScrollEvent();

// リサイズ時にも判定
window.addEventListener("resize", handleScrollEvent);


/* ----------------------------------
　HOME 採用情報 画像フェードイン
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".index_recruit_image");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        // 遅延をつけて順番にアニメーション
        setTimeout(() => {
          entry.target.classList.add("is_active_recruit");
        }, i * 300); // 0.3秒ずつ遅らせる

        observer.unobserve(entry.target); // 1回だけでOKなら監視解除
      }
    });
  }, {
    threshold: 0.5 // 30%見えたら発火
  });

  targets.forEach(target => observer.observe(target));
});


/* ----------------------------------
　フェードイン
---------------------------------- */
window.addEventListener("load", () => {
  setTimeout(() => {
    const fadeEls = document.querySelectorAll(".fade-in");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target); // 一度だけ表示したいなら
        }
      });
    }, {
      threshold: 0.1
    });

    fadeEls.forEach(el => observer.observe(el));
  }, 1500); // ← 3秒（3000ミリ秒）後に発火
});


/* ----------------------------------
　HOME＞about,採用情報＞Instagram　タイトルフェードイン
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  // 複数のターゲットをまとめて取得
  const targets = document.querySelectorAll('.recruit_instagram_ttl, .index_about_ttl-wrap');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-show');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  // それぞれ監視開始
  targets.forEach(target => observer.observe(target));
});

/* ----------------------------------
　施工事例＞年別ボタン　SP時開閉
---------------------------------- */


if (document.body.classList.contains('works_tax') || document.body.classList.contains('works')) {
  const toggleBtn = document.getElementById('category_menu_toggle');
  const menu = document.querySelector('#category_menu');
  const menuList = document.querySelector('.works_year-btns_list');

  if (toggleBtn && menu && menuList) {
    toggleBtn.addEventListener('click', () => {
      menu.classList.toggle('is-open');
      menuList.classList.toggle('is-open');
    });
  }
}
